import {ApiResource} from 'common/util/model-resource/api-resource';
import {ProjectTeam} from 'common/types/app-api/project-team';

import {projectTeamsClient} from '../queries/app-api/project-teams-client';

export class ProjectTeamsResource extends ApiResource<ProjectTeam> {
  apiClient = projectTeamsClient;
}
